'use strict';

require('./build/buildDateRangeUnitsCall');

// This package does not export anything as it is
// simply defining "weeks" on Range.prototype.


// WEBPACK FOOTER //
// ./~/sugar-date/range/weeks.js